import store from '@/vuex/store'
import Socket from '@/socket'

const castingUser = {
  id: 'guest',
  avatar: null,
  firstName: 'Guest',
  lastName: '',
  email: null,
  accountRole: null,
}

const joinRoomPresentationForUser = (uniqueAccesscode, user) => {
  const {
    id, avatar, firstName, lastName, email, accountRole,
  } = user

  Socket.getSocket().emit('join-presenter', {
    room: `${uniqueAccesscode}-presenter`,
    presenter: {
      id,
      avatar,
      name: lastName ? `${firstName} ${lastName}` : firstName,
      socketId: Socket.getSocketId(),
      email,
      accountRole,
    },
  })
}

const joinRoomPresentation = (uniqueAccesscode) => {
  return joinRoomPresentationForUser(uniqueAccesscode, store.state.currentUser)
}

const joinRoomPresentationAsGuest = (uniqueAccesscode) => {
  return joinRoomPresentationForUser(uniqueAccesscode, castingUser)
}

const leaveRoomPresentation = (uniqueAccessCode) => {
  Socket.getSocket().emit('leave', `${uniqueAccessCode}-presenter`)
}

const leaveRoomSlide = (uniqueAccessCode, slideId) => {
  Socket.getSocket().emit('leave', `${uniqueAccessCode}-${slideId}-presenter`)
}

const updateOldParticipants = (uniqueAccessCode, presentationId) => {
  Socket.getSocket().emit('update-old-participant', { uniqueAccessCode, presentationId })
}

const joinRoomSlideForUser = (uniqueAccessCode, slideId, user) => {
  const {
    id, avatar, firstName, lastName, email,
  } = user
  Socket.getSocket().emit('join-presenter', {
    room: `${uniqueAccessCode}-${slideId}-presenter`,
    presenter: {
      id,
      avatar,
      name: lastName ? `${firstName} ${lastName}` : firstName,
      socketId: Socket.getSocketId(),
      email,
    },
  })
}

const joinRoomSlide = (uniqueAccessCode, slideId) => {
  return joinRoomSlideForUser(uniqueAccessCode, slideId, store.state.currentUser)
}

const joinRoomSlideAsGuest = (uniqueAccessCode, slideId) => {
  return joinRoomSlideForUser(uniqueAccessCode, slideId, castingUser)
}

const backstageControl = ({
  uniqueAccessCode,
  isForAudience,
  type,
  data,
}) => {
  if (store.getters['remoteControlLink/canDisableBackstageControlEvents']) {
    return
  }
  Socket.getSocket().emit('backstage-control', {
    uniqueAccessCode,
    isForAudience,
    socketId: Socket.getSocketId(),
    type,
    data,
  })
}

export default {
  joinRoomPresentation,
  joinRoomSlide,
  leaveRoomPresentation,
  leaveRoomSlide,
  backstageControl,
  updateOldParticipants,
  joinRoomPresentationAsGuest,
  joinRoomSlideAsGuest,
}
